export default "__VITE_ASSET__Dm11STW0__"